module.exports = "<div class=\"display-contact-info\"> <div class=\"display-contact-info__name\">{{$ctrl.firstName}} {{$ctrl.lastName}}</div> <div class=\"display-contact-info__contact\"> <div class=\"display-contact-info__email\">{{$ctrl.email}}</div> <div class=\"display-contact-info__phone\">{{$ctrl.phone}}</div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/editAccountContactAndDelivery/displayContactInfo/displayContactInfo.html
// module id = 889
// module chunks = 0